export const ERROR_INCORRECT_EMAIL = "Enter the email";
export const ERROR_INCORRECT_PASSWORD_FIELD = "Enter the password";
export const ERROR_INCORRECT_RETRY_PASSWORD_FIELD =
  "The passwords do not match";
export const ERROR_NO_VALID_PASSWORD =
  "Passwords should be at least 8 characters but 10 or more is better.";
export const ERROR_INCORRECT_EMAIL_OR_PASSWORD = "Incorrect email or password";
export const ERROR_USER_ALREADY_EXIST = "User already exist";
export const ERROR_NO_TOKEN =
  "Please complete the security check before logging in";
